import {AxiosResponse} from 'axios'

import {api} from '../../../App.store'
import {Announcement} from '../Announcements'
import {AnnouncementFormData} from '../components'

export const createAnnouncement = async (data: AnnouncementFormData) => {
  const response: AxiosResponse<Announcement> = await api.post('/announcements', data)
  return response.data
}

export const updateAnnouncement = (messageId?: string) => async (data: AnnouncementFormData) => {
  if (!messageId) {
    throw new Error('MessageId must be provided')
  }

  const response: AxiosResponse<Announcement> = await api.put(`/announcements/${messageId}`, data)
  return response.data
}

export const deleteAnnouncement = (messageId?: string) => async () => {
  return messageId && (await api.delete(`/announcements/${messageId}`))
}
